import React from "react";
import TwoFAInputs from "./TwoFAInputs";
import PasswordInput from "./PasswordInput";
import { useRealtimeValidation } from "../../hooks/useRealtimeValidation";

const ForgotPasswordForm = ({ step, email, onEmailChange, code, onCodeChange, inputsRef, newPassword, confirmPassword, onPasswordChange, loading, cooldown, onResend, onSubmit, onBack }) => {
  const { fieldErrors, updateFieldError } = useRealtimeValidation("signup");

  // Gestion du changement de l'email avec validation
  const handleEmailChange = (value) => {
    onEmailChange(value);
    updateFieldError("email", value);
  };

  // Gestion du changement de mot de passe avec validation
  const handlePasswordChange = (field, e) => {
    const value = e.target.value;
    onPasswordChange(field, value);
    
    // Valider avec toutes les données pour la confirmation
    const allData = {
      newPassword: field === "newPassword" ? value : newPassword,
      confirmPassword: field === "confirmPassword" ? value : confirmPassword
    };
    updateFieldError(field, value, allData);
  };

  return (
    <>
      <button type="button" className="backButtonForgotPassword" onClick={onBack} style={{ marginBottom: "10px", padding: "5px 10px", fontSize: "12px" }}>← Retour</button>

      {step === "email" && (
        <>
          <h1 className="titleForgotPassword">Mot de passe oublié</h1>
          <span>Entrez votre adresse email pour recevoir un code de réinitialisation</span>
          <div className="field-wrapper">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => handleEmailChange(e.target.value)}
              invalid={fieldErrors.email ? "true" : undefined}
              data-error={fieldErrors.email || undefined}
            />
            {fieldErrors.email && <span className="field-error-message">{fieldErrors.email}</span>}
          </div>
          <button type="button" onClick={() => onSubmit("email")} disabled={loading}>
            {loading ? "..." : "Envoyer le code"}
          </button>
        </>
      )}

      {step === "code" && (
        <>
          <h1 className="titleForgotPassword">Vérifiez votre email</h1>
          <TwoFAInputs code={code} onCodeChange={onCodeChange} inputsRef={inputsRef} />
          <span>Saisissez le code reçu sur votre adresse mail</span>
          <button
            type="button"
            className="btnResend2FACode"
            onClick={onResend}
            disabled={cooldown > 0}
          >
            Envoyer à nouveau
            {cooldown > 0 && (
              <>
                <br />
                <span className="cooldownText">Disponible dans : {cooldown}s</span>
              </>
            )}
          </button>
          <button type="button" onClick={() => onSubmit("code")} disabled={loading}>
            {loading ? "..." : "Continuer"}
          </button>
        </>
      )}

      {step === "reset" && (
        <>
            <h1 className="titleForgotPassword">Créer un nouveau mot de passe</h1>
            <span>Entrez votre nouveau mot de passe</span>

            <div className="field-wrapper">
              <PasswordInput 
                name="newPassword" 
                placeholder="Nouveau mot de passe" 
                value={newPassword} 
                onChange={(e) => handlePasswordChange("newPassword", e)} 
                autoComplete="new-password"
                invalid={fieldErrors.newPassword ? "true" : undefined}
                data-error={fieldErrors.newPassword || undefined}
              />
              {fieldErrors.newPassword && <span className="field-error-message">{fieldErrors.newPassword}</span>}
            </div>
            <div className="field-wrapper">
              <PasswordInput 
                name="confirmPassword" 
                placeholder="Confirmer le mot de passe" 
                value={confirmPassword} 
                onChange={(e) => handlePasswordChange("confirmPassword", e)} 
                autoComplete="new-password"
                invalid={fieldErrors.confirmPassword ? "true" : undefined}
                data-error={fieldErrors.confirmPassword || undefined}
              />
              {fieldErrors.confirmPassword && <span className="field-error-message">{fieldErrors.confirmPassword}</span>}
            </div>
          
            <button type="button" onClick={() => onSubmit("reset")} disabled={loading}>
                {loading ? "..." : "Réinitialiser le mot de passe"}
            </button>
        </>
      )}
    </>
  );
};

export default ForgotPasswordForm;
